<template>
<div class="chapter">
<div class="inner_page">
<section aria-labelledby="headertoc01" class="chapter" epub:type="toc" id="toc" role="doc-toc">
<header id="headertoc01">
<h1 class="ctfm"><span aria-label=" Page v. " class="page" epub:type="pagebreak" id="pv" role="doc-pagebreak"></span>Contents</h1>
</header>
<p class="tocfm" id="rch01"><a class="xref" href="#/wsugold0006#ch01">Translator’s Introduction</a></p>
<p class="tocf" id="rheads"><a class="xref" href="#/wsugold0007#heads"><i>Your Comrade, Avreml Broide</i></a></p>
<p class="tocpt" id="rpt01"><a class="xref" href="#/wsugold0010#pt01">First Part: The City of the Shtetl</a></p>
<p class="tocpt" id="rpt02"><a class="xref" href="#/wsugold0020#pt02">Second Part: The City of New York</a></p>
<p class="tocbmf" id="rch21"><a class="xref" href="#/wsugold0032#ch21">Translator’s Acknowledgments</a></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// wsu-gold-0005.vue?602d490e